var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsHerzstolpern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 -1 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-herzstolpern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "monitor-heart-rate",
    stroke: "#7F8BDB"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 23,
    height: 23,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9 L3.732,9 C3.89923409,8.99991358 4.05535232,8.9162252 4.148,8.777 L5.584,6.623 C5.67673659,6.48392244 5.83283947,6.40038782 6,6.40038782 C6.16716053,6.40038782 6.32326341,6.48392244 6.416,6.623 L7.5,8.243 C7.60122921,8.3946659 7.77699633,8.47919771 7.95867266,8.46358978 C8.140349,8.44798184 8.29912262,8.33470942 8.373,8.168 L9.473,5.705 C9.55720917,5.51484792 9.75032747,5.39667372 9.95796984,5.40823411 C10.1656122,5.4197945 10.3444191,5.55867546 10.407,5.757 L12.433,12.174 C12.5015603,12.3906306 12.7075693,12.5337933 12.9345102,12.5225168 C13.161451,12.5112402 13.3522529,12.3483601 13.399,12.126 L15.099,3.983 C15.1462068,3.75808972 15.3406463,3.59431982 15.5703079,3.58603306 C15.7999695,3.5777463 16.0057064,3.72707685 16.069,3.948 L17.4,8.637 C17.4612196,8.8518786 17.6575707,9.00006039 17.881,9 L23,9",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,19.996 L3.091,16.443 C2.4771678,15.8291923 2.32491211,14.8914906 2.713,14.115 L2.713,14.115 C3.00301484,13.5352374 3.55401169,13.1302 4.19390004,13.0263915 C4.83378839,12.922583 5.4845741,13.1326562 5.943,13.591 L6.5,14.148 L7.057,13.591 C7.5154259,13.1326562 8.16621161,12.922583 8.80609996,13.0263915 C9.44598831,13.1302 9.99698516,13.5352374 10.287,14.115 L10.287,14.115 C10.6750879,14.8914906 10.5228322,15.8291923 9.909,16.443 L6.5,19.996 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsHerzstolpern);
export default __webpack_public_path__ + "static/media/icons-herzstolpern.c96d7464ed43abcf1ca81e79992306e9.svg";
export { ForwardRef as ReactComponent };